import React, { useContext, useState } from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import thirpleDotIcon from "../../Assets/Images/thirple-dot-icon.png";
import thirpleDotDarkIcon from "../../Assets/Images/thirple-dot-dark-icon.png";
import styled from "@emotion/styled";
import { DynamicContext } from "../../Context/DynamicContext";

const StyledMenu = styled(Menu)({
  "& .MuiList-root": {
    padding: "0px",
    backgroundColor: "var(--body__background)",
    color: "var(--header__color)",
  },
});

const StyledMenuItem = styled(MenuItem)({
  "&:hover": {
    backgroundColor: "var(--chat_tab_hover)",
    color: "var(--header__color)",
  },
});

const Menuselector = ({
  options,
  onSelect,
  menuStyle,
  itemStyle,
  onOpen,
  onClose,
  rowIndex,
  disabled,
}) => {
  const { isDarkMode } = useContext(DynamicContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");

  const handleClick = (event) => {
    if (disabled) return;
    setAnchorEl(event.currentTarget);
    if (onOpen) onOpen(rowIndex);
  };

  const handleClose = () => {
    setAnchorEl(null);
    if (onClose) onClose();
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option.name);
    onSelect(option.name);
    handleClose();
  };

  const defaultItemStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "8px",
    padding: "8px 16px",
    "&:hover": {
      backgroundColor: "var(--chat_tab_hover)",
    },
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="menu-selector"
        aria-haspopup="true"
        onClick={handleClick}
        disabled={disabled}
      >
        <img
          src={isDarkMode ? thirpleDotDarkIcon : thirpleDotIcon}
          alt="thirple-dot-icon"
          className="thirple-dot-icon"
        />
      </IconButton>
      <StyledMenu
        id="menu-selector"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        disableScrollLock={true}
        sx={menuStyle}
      >
        {options.map((option, index) => (
          <StyledMenuItem
            sx={{ ...defaultItemStyle, ...itemStyle }}
            className="menu-item"
            key={index}
            selected={option === selectedOption}
            onClick={() => handleOptionSelect(option)}
            disabled={disabled}
          >
            <img
              src={option.icon}
              alt={option.name}
              style={{ width: 24, height: 24 }}
            />
            {option.name}
          </StyledMenuItem>
        ))}
      </StyledMenu>
    </div>
  );
};

export default Menuselector;
